export default "__VITE_ASSET__06f4d151__"